export const FAVORITE_REDUCER = "FAVORITE_REDUCER";
export const EXCLUSION_REDUCER = "EXCLUSION_REDUCER";